/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ui/NG_DOT_NAV': {
    width: 16,
    height: 16,
    viewBox: '0 0 11 11',
    data: '<path pid="0" d="M5.5 11A5.5 5.5 0 1 1 11 5.5 5.51 5.51 0 0 1 5.5 11zm0-9A3.5 3.5 0 1 0 9 5.5 3.5 3.5 0 0 0 5.5 2z" _fill="#545454"/>'
  }
})



// WEBPACK FOOTER //
// ./src/components/app-icons/ui/NG_DOT_NAV.js